var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.isGoogleApiLoaded)?_c('vue-google-heatmap',{attrs:{"points":_vm.points,"lat":46.7784,"lng":23.6172,"initial-zoom":13,"options":{mapTypeControl: false},"width":"100%","height":"100vh"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }